module.exports = EhsReact.React;